import { Controller } from "@hotwired/stimulus"

// The partner key is typed on New, like legacy's "Partner ID", and filled in
// from the name until the admin edits it themselves (independent QA). The same
// rule as Partner#auto_generate_external_key: accents dropped, lowercase, no spaces.
export default class extends Controller {
  static targets = ["name", "key"]

  fill() {
    if (!this.hasKeyTarget || this.keyTarget.dataset.edited === "true") return

    this.keyTarget.value = this.nameTarget.value
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .toLowerCase().replace(/\s+/g, "").replace(/[^a-z0-9_-]/g, "")
  }

  edited() {
    this.keyTarget.dataset.edited = this.keyTarget.value === "" ? "false" : "true"
  }
}
